import {
	CHECK_AUTH_STATE_START,
	CHECK_AUTH_STATE_SUCCESS,
	CHECK_AUTH_STATE_FAIL,
	LOGIN_START,
	LOGIN_SUCCESS,
	LOGIN_FAIL,
} from 'client/constants';

const initialState = '';

export default function isBusyReducer(state = initialState, { type, payload }) {
	switch (type) {
		case CHECK_AUTH_STATE_START:
		case LOGIN_START:
			return 'auth';

		case CHECK_AUTH_STATE_SUCCESS:
		case CHECK_AUTH_STATE_FAIL:
		case LOGIN_SUCCESS:
		case LOGIN_FAIL:
			return '';

		default:
			return state;
	}
}
